import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend'; // Import the backend

i18n
  // Load translations using http -> see /public/locales
  // Learn more: https://github.com/i18next/i18next-http-backend
  .use(HttpApi)
  // Detect user language
  // Learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // Init i18next
  // For all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: import.meta.env.DEV, // Enable debug output in development
    fallbackLng: 'en', // Use 'en' if detected language is not available
    supportedLngs: ['en', 'pt', 'fr'], // Explicitly list supported languages
    interpolation: {
      escapeValue: false, // React already safes from xss
    },
    backend: {
      // Path where resources get loaded from
      loadPath: '/locales/{{lng}}/translation.json',
    },
    // Remove static resources if they were added for testing
    // resources: {
    //   en: {
    //     translation: {
    //       "settings.title": "Settings"
    //     }
    //   },
    //   pt: {
    //     translation: {
    //       "settings.title": "Definições"
    //     }
    //   }
    // }
  })
  .catch((err: unknown) => {
    console.error('Error initializing i18next:', err);
  });

export default i18n;
